import React from "react";
import DeleteAccountFlow from "../Components/DeleteAccountFlow";

const DeleteAccount = () => {
  return <DeleteAccountFlow variant="delete-page" />;
};

export default DeleteAccount;
